/**
 * §P.8 · El marco de «Cumplimiento»: las pestañas y el guardián.
 *
 * El porqué de que esto sea una sección propia y no dos pestañas más de «El club»
 * está en `club/secciones.ts`, junto a la deuda que abre.
 */
import { Link, Navigate, Outlet, useRouterState } from '@tanstack/react-router';
import { vistasDeCumplimientoPara } from '@/club/secciones';
import { useContextoDelClub } from '@/club/contexto';
import { puedeVerCumplimiento } from '@/club/permisos';

export function MarcoDeCumplimiento() {
  const camino = useRouterState({ select: (s) => s.location.pathname });
  const { rol } = useContextoDelClub();

  if (!puedeVerCumplimiento(rol)) return <Navigate to="/alumnos" replace />;

  return (
    <>
      <nav className="pestañas" aria-label="Pantallas de cumplimiento">
        {vistasDeCumplimientoPara(rol).map((v) => {
          const destino = `/cumplimiento/${v.id}`;
          return (
            <Link
              key={v.id}
              to={destino}
              className={
                camino.startsWith(destino) ? 'pestaña-activa' : 'btn-plano'
              }
            >
              {v.etiqueta}
            </Link>
          );
        })}
      </nav>

      <Outlet />
    </>
  );
}
